export const BASE_URL = 'https://55evcsrblc.execute-api.eu-west-2.amazonaws.com/prod';